<template>
  <header class="top-menu header fixed-top">
    <nav>
      <!-- Sidebar toggle button-->
      <div class="float-left">
        <span class="content-route"><i :class="$route.meta.icon"></i></span>
        <span class="content-route" v-html="$route.meta.title"></span>
      </div>
      <div class="navbar-right">
        <div class="hidden-sm-down btn-group custom-shortcuts" v-if="!$store.state.auth.me.roles.includes('client_sub') && !$store.state.auth.me.roles.includes('client_auth')">
          <router-link v-if="crmType === 'recruitment'" to="/charge_rate_calculator" data-toggle="tooltip" title="Charge rate calculator"><i class="fas fa-calculator"></i></router-link>
          <router-link to="/orders/create" data-toggle="tooltip" title="New Order"><i class="fas fa-clipboard"></i></router-link>
          <router-link to="/companies/create" data-toggle="tooltip" title="New Company"><i class="fas fa-building"></i></router-link>
          <router-link to="/workers/register" data-toggle="tooltip" title="New Worker"><i class="fas fa-user-edit"></i></router-link>
        </div>

        <div class="time hidden-sm-down">{{ currentTime }}</div>

        <div class="hidden-sm-down btn-group fullscreen" v-if="fullscreen">
          <a @click.prevent="fullscreen" data-toggle="tooltip" title="Fullscreen"><i class="fas fa-expand-arrows-alt"></i></a>
        </div>
        <!-- User Account: style can be found in dropdown-->
        <b-dropdown class="user user-menu" right offset="0">
          <template v-slot:button-content>
            <!--            <img :src="'/storage/users/avatars/' + $store.state.user.id + '/' + $store.state.user_profile.avatar_filename"-->
            <!--                 alt="User Image" class="user_avatar">-->
            <!--User name-->
            <span class="user_name_max">{{ $store.state.auth.me.first_name }} {{ $store.state.auth.me.surname }}</span>
          </template>
          <!--     <b-dropdown-item exact class="dropdown_content" to="/register_worker"><i class="fas fa-user"></i> My Profile</b-dropdown-item>-->
          <!--     <b-dropdown-item exact class="dropdown_content" to="/register_worker"><i class="fas fa-user-cog"></i> My Settings</b-dropdown-item>-->
          <!--     <b-dropdown-item exact class="dropdown_content" to="/register_worker"><i class="fas fa-align-left"></i> My Activity Log</b-dropdown-item>-->
          <!--     <hr class="mt-1 mb-1">-->
          <b-dropdown-item exact class="dropdown_content" v-on:click="lock"><i class="fas fa-lock"></i> Lock</b-dropdown-item>
          <b-dropdown-item exact class="dropdown_content" v-on:click="logout"><i class="fas fa-sign-out-alt"></i> Logout</b-dropdown-item>
        </b-dropdown>
      </div>
    </nav>
  </header>
</template>
<script>
import screenfull from "screenfull";

export default {
  name: "top_menu",
  data() {
    return {
      currentTime: '',
      crm_search: '',
    }
  },
  created() {
    this.currentTime = this.$moment().format('HH:mm:ss ddd DD/MM');
    setInterval(() => this.updateCurrentTime(), 1000);

    // this.listenForChanges();
  },
  methods: {
    fullscreen() {
      if (screenfull.isEnabled) {
        screenfull.toggle();
      }
    },
    updateCurrentTime() {
      this.currentTime = this.$moment().format('HH:mm:ss ddd DD/MM');
    },
    lock() {
      this.$store.commit('LOGIN_LOCK', true);
      this.$nextTick(() => this.$router.push('/login_lock'))
    },
    logout() {
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Confirm Logout</div>' +
            '<div class="snotifyToast__body">' +
            'Are you sure that you wish to logout?' +
            '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
            '</div>',
        buttons: [
          {
            text: 'Yes', action: (toast) => {
              this.$snotify.remove(toast.id);
              this.$store.commit('COMMIT_CRM_LOADED', false)
              this.$nextTick(() => this.$router.push('/logout'))
            }
          },
          {text: 'No', action: (toast) => this.$snotify.remove(toast.id)}
        ]
      });
    }

    // listenForChanges() {
    //   Echo.channel('GM-CRM').listen('ClientTimesheetSubmitted', post => {
    //     if (!('Notification' in window)) {
    //       alert('Web Notification is not supported');
    //       return;
    //     }
    //
    //     Notification.requestPermission(permission => {
    //       let notification = new Notification('New post alert!', {
    //         body: post.client_id, // content for the alert
    //         // icon: "https://pusher.com/static_logos/320x320.png" // optional image url
    //       });
    //
    //       // link to page on clicking the notification
    //       notification.onclick = () => {
    //         window.open(window.location.href);
    //       };
    //     });
    //   })
    // }
  },
  beforeDestroy() {
    this.currentTime = '';
    this.crm_search = '';
  }
}
</script>
<style lang="scss">
.top-menu {
  left:            $sb_width;
  z-index:         999;
  transition:      all 0.3s;
  background:      $bc_1;
  background-size: 100% 100%;
  box-shadow:      0 3px 6px -3px rgba($black, 0.6);

  .content-route {
    font-family:    $font-family-header;
    line-height:    $tm_height;
    margin-left:    15px;
    font-size:      1.35rem;
    font-weight:    700;
    color:          $white;
    margin-bottom:  0;
    display:        inline-block;
    vertical-align: top;
    text-transform: uppercase;

    &:nth-of-type(2) {
      margin-left: 5px;
      font-size:   1rem;
    }
  }

  .navbar-right {
    float:        right;
    margin-right: 15px;
    line-height:  $tm_height;
    height:       $tm_height;

    .search {
      height: $tm_height;
      /*padding: 10px;*/

      ::-webkit-input-placeholder {
        color: $white !important;
      }

      :-moz-placeholder {
        color: $white !important;
      }

      ::-moz-placeholder {
        color: $white !important;
      }

      :-ms-input-placeholder {
        color: $white !important;
      }

      .form-control-search {
        font-size:      0.85rem;
        width:          16px;
        height:         20px;
        line-height:    20px;
        text-align:     center;
        pointer-events: none;
        color:          #ffffff;
        vertical-align: top;
        position:       absolute;

        i {
          line-height: 38px;
        }
      }

      #crm_search {
        height:         34px;
        min-height:     34px;
        margin-top:     3px;
        margin-bottom:  3px;
        width:          200px;
        vertical-align: top;
        padding:        1px 1px 1px 20px;
        color:          $white;
        box-shadow:     none;

        &::-webkit-search-cancel-button {
          -webkit-appearance: none;
        }
      }
    }

    .time {
      font-family:    $font-family-header;
      font-size:      1.15em;
      font-weight:    700;
      color:          $white;
      margin-bottom:  0;
      line-height:    $tm_height;
      vertical-align: top;
      display:        inline-block;
      min-width:      160px;
      text-align:     center;
    }

    .fullscreen, .notifications, .custom-shortcuts {
      vertical-align: top;

      a {
        color:      $tm_icon_color;
        width:      40px;
        text-align: center;
        font-size:  1rem;

        &:hover, &:focus, &:active, &:active:focus, &.active, &.active.focus, &:active.focus {
          cursor:           pointer;
          background-color: $tm_icon_active_background;
          box-shadow:       none;
        }
      }
    }

    .user-menu {
      outline:        0;
      vertical-align: top;

      .btn {
        background-color: transparent;
        border:           none;
        height:           $tm_height;
        line-height:      $tm_height;
        padding-top:      0;
        padding-bottom:   0;
        border-radius:    0;
        outline:          0;
        color:            $white;

        .user_avatar {
          vertical-align: top;
          height:         25px;
          width:          25px;
          margin-top:     7.5px;
          margin-bottom:  7.5px;
          border-radius:  7px;
        }

        .user_name_max {
          display:        inline-block;
          white-space:    nowrap;
          overflow:       hidden !important;
          text-overflow:  ellipsis;
          margin:         0 0 0 7px;
          color:          $white;
          font-weight:    700;
          vertical-align: top;
        }

        &:after {
          border-top-color:    $white;
          border-bottom-color: $white;
          margin-top:          18px;
          margin-left:         10px;
          vertical-align:      top;
        }

        &[aria-expanded = 'true'] {
          &:after {
            border-top:    0;
            border-bottom: 0.3em solid;
          }
        }

        &:hover, &:focus, &:active, &:active:focus, &.active, &.active.focus, &:active.focus {
          cursor:           pointer;
          background-color: $tm_user_menu_btn_active_background;
          box-shadow:       none;
        }
      }

      &.show {
        .dropdown-toggle {
          background-color: $tm_user_menu_btn_active_background;
        }

        .dropdown-menu {
          &.show {
            margin-top:       0;
            background-color: $sb_user_menu_dropdown_background;
            border-radius:    0;
            padding:          5px;
            right:            0;
            left:             initial !important;
            box-shadow:       0 2px 3px 0 rgba(0, 0, 0, 0.5);
            transform:        translate3d(0px, 39px, 0px) !important;
          }

          hr {
            border-color: $white;
          }

          .dropdown_content {
            background-color: transparent;
            line-height:      30px;

            .dropdown-item {
              padding:         5px 7.5px;
              color:           $white;
              text-decoration: none;

              i {
                margin-right: 5px;
                width:        25px;
                text-align:   left;
                font-size:    1.05rem;
              }

              &:hover, &:focus, &:active, &:active:focus, &.active, &.active.focus, &:active.focus {
                cursor:           pointer;
                background-color: $sb_user_menu_dropdown_link_hover_background;
              }
            }
          }
        }
      }
    }
  }
}
</style>
